<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form" v-model="valid">
                <v-container style="max-width: 1200px" py-5>
                    <h1 class="pt-5 pb-5">Регистрация сотрудника</h1>

                    <v-layout v-if="role!='agent'" row wrap pb-5>
                        <v-flex xs12 md10 lg8 py-0>
                            <v-autocomplete
                                v-model="agentId"
                                :items="agentsList"
                                label="Для агента"
                                :rules="[rules.notNullOrEmpty]"
                                required
                                item-value="value"
                                item-text="text"
                            ></v-autocomplete>
                        </v-flex>
                    </v-layout>

                    <h3 class="pt-5 pb-4">Данные сотрудника</h3>

                    <v-layout row wrap>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.surname"
                                allowAll="true"
                                label="Фамилия"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.name"
                                allowAll="true"
                                label="Имя"
                            />
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <osago-name
                                v-model="fio.patronymic"
                                allowAll="true"
                                label="Отчество"
                            />
                        </v-flex>
                    </v-layout>

                    <v-layout row wrap pb-2>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                v-model="user.phone"
                                :rules="[rules.phone]"
                                mask="+7 ### ### ## ##"
                                label="Телефон"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 pt-0>
                            <v-text-field
                                v-model="user.email"
                                :rules="[rules.email]"
                                label="Е-mail (является логином для входа в ЛК)"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12 lg4 py-0>
                            <osago-city-dadata :model="city"></osago-city-dadata>
                        </v-flex>
                        <v-flex xs12 md3 lg2 pt-0>
                            <v-checkbox v-model="user.show_commission" label="Показывать КВ"></v-checkbox>
                        </v-flex>
                        <v-flex xs12 md6 lg4 pt-0>
                            <v-checkbox v-model="user.show_commission_bp" label="Показывать КВ (Банковские продукты)"></v-checkbox>
                        </v-flex>
                    </v-layout>

                    <h3 class="pt-5 pb-3">Пароль</h3>
                    <v-layout row wrap>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                :type="showPass ? 'text' : 'password'"
                                v-model="user.password"
                                :rules="[rules.password]"
                                label="Пароль (не менее 7 символов)"
                                validate-on-blur
                                required
                            >
                                <template v-slot:append>
                                    <v-icon class="material-symbols-outlined pointer" @mousedown.stop.prevent="showPass = !showPass">
                                        {{ showPass ? 'visibility' : 'visibility_off' }}
                                    </v-icon>
                                </template>
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 lg4 py-0>
                            <v-text-field
                                :type="showPass ? 'text' : 'password'"
                                v-model="user.password_check"
                                :rules="[passwordCheckRule]"
                                label="Повторите пароль"
                                validate-on-blur
                                required
                            >
                                <template v-slot:append>
                                    <v-icon class="material-symbols-outlined pointer" @mousedown.stop.prevent="showPass = !showPass">
                                        {{ showPass ? 'visibility' : 'visibility_off' }}
                                    </v-icon>
                                </template>
                            </v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout pt-5 pb-5 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn @click="validate"
                                   :disabled="false"
                                   class="submit-button block">Отправить</v-btn>
                        </v-flex>
                    </v-layout>

                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
    export default {
        props: ['role', 'agent', 'agents'],

        data: () => ({
            valid: true,
            agentId: null,
            agentsList: [],
            isJuridical: true,
            user: {
                phone: '+7',
                email: '',
                password: '',
                password_check: '',
                show_commission: false,
                show_commission_bp: false,
                is_egarant: false,
                egarant_company: null
            },
            fio: {
                name: '',
                surname: '',
                patronymic: '',
            },
            city: {
                city: '',
                search: '',
                city_kladr: null,
                city_fias: null
            },

            rules: {
                required: v => !!v || 'Обязательное поле',
                integer: v => Number.isInteger(v) || 'Обязательное поле',
                email: v => /.+@.+\..+/.test(v) || 'Неверный формат',
                phone: v => /^\d{11}$/.test(v) || 'Неверный формат',
                password: v => v.length >= 7 || 'Пароль должен содержать не менее 7 символов',
                notNullOrEmpty: v => (v !== null && v !== '') || 'Обязательное поле'
            },

            showPass: false,
        }),

        computed: {
            passwordCheckRule() {
                return () => this.user.password === this.user.password_check || 'Пароли не совпадают';
            },
        },

        created: function () {
            this.agentId = this.agent;
            if (this.role !== 'agent') {
                this.agentsList = JSON.parse(window.atob(this.agents));
            }
        },

        mounted: function () {
            //window.tippy.default('.tip-icon');
        },

        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.submit();
                } else {
                    this.$nextTick(function() {
                        PNotify.error('Проверьте правильность выделенных полей.');
                        this.goToFirstError();
                    });
                }
            },

            goToFirstError() {
                this.$vuetify.goTo('.error--text', {
                    duration: 600,
                    offset: 150,
                    easing: 'easeInCubic',
                });
            },

            submit() {
                axios.post(window.location, {
                    agent_id: this.agentId,
                    user: this.user,
                    fio: this.fio,
                    city: this.city,
                }).then(response => {
                    window.location.href = response.data.redirectTo;
                }).catch(error => {
                    console.log(error.response);
                    PNotify.error(error.response.data.message);
                });
            },

        }
    }
</script>

<style scoped>
    a.policy {
        color: #00ba57;
    }

    .policy-wrapper {
        text-align: left;
        display: table-cell;
        vertical-align: middle;
        height: 100px;
    }

    .driverControls a {
        color: #000000;
    }

    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 24px !important;
        text-transform: none !important;
        box-shadow: none !important ;

        height: 100px;
        background-color: #00ba57 !important;;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 0 200px;
        line-height: 1.1;
    }

    .preview-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 19px !important;
        text-transform: none !important;
        box-shadow: none !important ;

        height: 70px;
        width: 90%;
        background-color: #00ba57 !important;;
        text-align: center;
        padding: 0 30px !important;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;

        /*        font-size: 46px;
                line-height: 1.55;
                font-weight: 400;*/
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    .preloading {
        position: relative;
        z-index: 999;
        height: 100%;
        width: 100%;
        max-width: 100%;
        overflow: visible;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;

        background: white;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    .preloader-circle {
        background: #00ba57;
        width: 100px;
        height: 100px;
        margin: auto;
        border-radius: 100%;
        -webkit-animation:grow 1s infinite;
    }

    .pointer {
        cursor: pointer;
    }

    @-webkit-keyframes grow {
        0% {
            -webkit-transform: scale( 0.7 )
        }

        50% {
            -webkit-transform: scale( 0.9 )
        }

        100% {
            -webkit-transform: scale( 0.7 )
        }
    }

    /deep/ .preview-text-label {
        color: #585858;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/RegisterOperator.vue